/* Barnaby — client-side profanity guard (Layer 1).
   First-line UX filter on printable loop text (moments / names / messages / chapters).
   The AI path is ALSO moderated server-side (story-ideas → OpenAI Moderation), so this is
   intentionally conservative: it aims to catch the obvious cases without false-positiving on
   ordinary warm gift messages. Exposes:  window.bbHasProfanity(text) -> boolean.
   Deliberately client-side = convenience/UX, not hard enforcement. */
(function () {
  // Normalise so simple obfuscation still matches: lowercase, common leet swaps, non-letters
  // collapse to spaces (keeps word boundaries), 3+ repeats collapsed (fuuuuck -> fuuck).
  function normWords(s) {
    return String(s == null ? '' : s).toLowerCase()
      .replace(/[1!|]/g, 'i').replace(/3/g, 'e').replace(/[4@]/g, 'a')
      .replace(/0/g, 'o').replace(/[5$]/g, 's').replace(/7/g, 't')
      .replace(/[^a-z]+/g, ' ')
      .replace(/(.)\1{2,}/g, '$1$1')
      .trim();
  }
  function normTight(s) { return normWords(s).replace(/\s+/g, ''); }

  // Whole-word matches (token === entry) — safe from the "Scunthorpe problem" because it only
  // matches a standalone word, not a substring of an innocent one.
  var WORDS = {};
  ('fuck fucker fuckers fucking fucked fuckin motherfucker shit shite shitty bullshit ' +
   'cunt cunts bitch bitches bastard bastards dick dickhead dickheads prick pricks cock cocks ' +
   'wanker wankers wank twat twats bollocks arse arsehole arseholes asshole assholes ass ' +
   'bugger slut sluts whore whores slag slags tits piss pissed pussy pussies ' +
   'nigger niggers nigga niggas faggot faggots fag fags retard retards retarded spastic spaz ' +
   'paki pakis chink chinks gook wog wogs coon coons kike kikes dyke dykes tranny trannies ' +
   'rape rapist molest paedo pedo nonce').split(' ')
    .forEach(function (w) { if (w) WORDS[w] = 1; });

  // Substring matches on the space-stripped text — catches spaced-out evasion ("c u n t").
  // ONLY terms that are essentially never inside an innocent English word (keeps false
  // positives near-zero — deliberately excludes short/ambiguous stems like ass/shit/dick).
  var TIGHT = ['fuck', 'motherfuck', 'cunt', 'wanker', 'faggot', 'nigger', 'nigga', 'bastard',
    'bollocks', 'twat', 'dickhead', 'arsehole', 'asshole', 'pussy', 'whore', 'rapist', 'paedo'];

  window.bbHasProfanity = function (text) {
    var w = normWords(text);
    if (!w) return false;
    var toks = w.split(' ');
    for (var i = 0; i < toks.length; i++) { if (WORDS[toks[i]]) return true; }
    var tight = w.replace(/\s+/g, '');
    for (var j = 0; j < TIGHT.length; j++) { if (tight.indexOf(TIGHT[j]) !== -1) return true; }
    return false;
  };

  // Convenience: does ANY value in a list trip the filter?
  window.bbAnyProfanity = function (values) {
    for (var i = 0; i < (values || []).length; i++) { if (window.bbHasProfanity(values[i])) return true; }
    return false;
  };
})();
